module.exports = __webpack_public_path__ + "static/media/17760452_10209298898576179_1139045755_n.7899a337.jpg";